import {
    HttpClient,
    HttpEventType,
} from '@angular/common/http';
import { Injector } from '@angular/core';
import { ODataValue } from '@models';
import { FileUploadService } from '@services/file.upload.service';
import { ODataService } from '@services/generics/odata.service';
import { MapperDefinition } from '@services/mapper.service';

import { filter } from 'rxjs/operators';

export abstract class BaseLicenseService<T> extends ODataService<T, number> {
    protected _endpoint = '';

    private _fileUploadService = this._injector.get<FileUploadService>(FileUploadService);

    constructor(
        http: HttpClient,
        mapper: MapperDefinition<T>,
        protected _injector: Injector,
    ) {
        super(http, mapper);
    }

    public uploadLicense(file: File) {
        const uploadEndpoint =
            `${this._endpoint}/UiPath.Server.Configuration.OData.UploadLicense()`;

        return this._fileUploadService
            .uploadFiles<T>([file], uploadEndpoint)
            .pipe(filter((ev) => ev.type === HttpEventType.Response));
    }

    public activateLicenseOnline(licenseKey: string, environment: string, email?: string) {
        const payload = JSON.stringify({
            licenseKey,
            environment,
            email,
        });

        return this._http.post(
            `${this._endpoint}/UiPath.Server.Configuration.OData.ActivateLicenseOnline`,
            payload);
    }

    public activateLicenseOffline(file: File) {
        return this._fileUploadService.uploadFiles([file], `${this._endpoint}/UiPath.Server.Configuration.OData.ActivateLicenseOffline()`);
    }

    public getLicenseOffline(licenseKey: string, environment: string, email?: string) {
        const payload = JSON.stringify({
            licenseKey,
            environment,
            email,
        });

        return this._http.post<ODataValue<string>>(
            `${this._endpoint}/UiPath.Server.Configuration.OData.GetLicenseOffline`,
            payload);
    }

    public updateLicenseOnline() {
        return this._http.post(
            `${this._endpoint}/UiPath.Server.Configuration.OData.UpdateLicenseOnline`,
            null);
    }

    public deactivateLicenseOnline(tenantId?: number) {
        const payload = JSON.stringify({
            tenantId,
        });

        return this._http.post(
            `${this._endpoint}/UiPath.Server.Configuration.OData.DeactivateLicenseOnline`,
            payload);
    }

    public getDeactivateLicenseOffline(tenantId?: number) {
        const payload = JSON.stringify({
            tenantId,
        });

        return this._http.post<ODataValue<string>>(
            `${this._endpoint}/UiPath.Server.Configuration.OData.GetDeactivateLicenseOffline`,
            payload);
    }
}
